import { render, staticRenderFns } from "./HomeArticles.vue?vue&type=template&id=f2de2a42&"
import script from "./HomeArticles.vue?vue&type=script&lang=js&"
export * from "./HomeArticles.vue?vue&type=script&lang=js&"
import style0 from "./HomeArticles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HomeArticles.vue"
export default component.exports